import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function AboutPage() {
  const timeline = [
    {
      year: '1995',
      title: 'The Beginning',
      description: 'Maria Gonzalez opened the doors of Stitch&Style in a small Newark storefront, bringing her passion for tailoring and 15 years of experience from her native Italy.',
    },
    {
      year: '2000',
      title: 'Expansion & Recognition',
      description: 'Expanded to a larger location and earned recognition as one of New Jersey\'s premier alteration services. Featured in New Jersey Bride Magazine.',
    },
    {
      year: '2008',
      title: 'Bridal Specialization',
      description: 'Launched our specialized bridal alteration division, becoming the go-to destination for wedding dress alterations in the tri-state area.',
    },
    {
      year: '2015',
      title: 'Second Generation',
      description: 'Maria\'s daughter, Isabella, joined the business, bringing fresh perspectives while honoring traditional craftsmanship techniques.',
    },
    {
      year: '2020',
      title: 'Modern Innovation',
      description: 'Introduced virtual consultations and online booking while maintaining our commitment to personalized, hands-on service.',
    },
    {
      year: '2024',
      title: 'Continued Excellence',
      description: 'Celebrating nearly three decades of service with over 10,000 satisfied customers and a team of master seamstresses.',
    },
  ];

  const team = [
    {
      name: 'Monsurat Ibrahim',
      role: 'Founder & Master Seamstress',
      image: 'https://static.readdy.ai/image/9f4be5d6608570871f974bc62daf0fe5/8735e4139fda9f119e1a340e60b65464.png',
      bio: 'With over 10 years of experience, specialized in alterations.',
    },
  ];

  const values = [
    {
      icon: 'ri-heart-line',
      title: 'Passion for Perfection',
      description: 'Every stitch is made with care and attention to detail, ensuring flawless results.',
    },
    {
      icon: 'ri-user-heart-line',
      title: 'Customer First',
      description: 'Your satisfaction is our priority. We listen, understand, and deliver beyond expectations.',
    },
    {
      icon: 'ri-award-line',
      title: 'Quality Craftsmanship',
      description: 'Traditional techniques meet modern innovation for superior alteration services.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Integrity & Trust',
      description: 'Honest pricing, transparent communication, and reliable service you can count on.',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="relative h-96 flex items-center justify-center bg-gradient-to-r from-amber-700 to-amber-900">
        <div className="absolute inset-0 opacity-20">
          <img
            src="https://public.readdy.ai/ai/img_res/de6ea239614a2ed1841bc03b0609acfd.jpg"
            alt="About Us"
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <h1 className="text-5xl md:text-6xl font-bold mb-6" style={{ fontFamily: '"Playfair Display", serif' }}>
            Our Story
          </h1>
          <p className="text-xl md:text-2xl max-w-3xl mx-auto">
            Bringing professional tailoring to your doorstep since 1995
          </p>
        </div>
      </section>

      {/* Our Story */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6" style={{ fontFamily: '"Playfair Display", serif' }}>
                Pioneering Mobile Alteration Services
              </h2>
              <div className="space-y-4 text-lg text-gray-600">
                <p>
                  Founded in 1995, Stitch&Style revolutionized the alteration industry by bringing professional tailoring services directly to customers' homes. We recognized that busy professionals, parents, and anyone with a hectic schedule deserved access to expert alterations without the hassle of traveling to a shop.
                </p>
                <p>
                  What started as a single tailor with a vision has grown into Newark's most trusted mobile alteration service. Our team of experienced professionals serves hundreds of satisfied customers throughout the greater Newark area, delivering convenience without compromising on quality.
                </p>
                <p>
                  We believe that exceptional tailoring should fit into your life, not the other way around. That's why we bring our expertise, equipment, and personalized service right to your doorstep, making professional alterations more accessible than ever.
                </p>
              </div>
            </div>

            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20heartwarming%20scene%20of%20mother%20and%20daughter%20seamstresses%20working%20together%20in%20bright%20elegant%20tailoring%20studio%20examining%20beautiful%20fabric%20with%20sewing%20equipment%20and%20dress%20forms%20in%20background%20showing%20family%20legacy%20and%20craftsmanship%20tradition%20with%20soft%20natural%20lighting%20and%20warm%20neutral%20tones&width=700&height=900&seq=about-story-1&orientation=portrait"
                alt="Our Story"
                className="rounded-lg shadow-2xl w-full h-auto object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Timeline */}
      <section className="py-20 bg-amber-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: '"Playfair Display", serif' }}>
              Our Journey
            </h2>
            <p className="text-xl text-gray-600">Nearly three decades of growth and excellence</p>
          </div>

          <div className="relative">
            <div className="absolute left-1/2 transform -translate-x-1/2 h-full w-1 bg-amber-700 hidden lg:block"></div>

            <div className="space-y-12">
              {timeline.map((item, index) => (
                <div
                  key={index}
                  className={`flex flex-col lg:flex-row items-center gap-8 ${
                    index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
                  }`}
                >
                  <div className="flex-1 lg:text-right">
                    {index % 2 === 0 && (
                      <div className="bg-white p-6 rounded-lg shadow-md">
                        <div className="text-3xl font-bold text-amber-700 mb-2">{item.year}</div>
                        <h3 className="text-2xl font-bold text-gray-900 mb-3">{item.title}</h3>
                        <p className="text-gray-700 leading-relaxed">{item.description}</p>
                      </div>
                    )}
                  </div>

                  <div className="w-16 h-16 flex items-center justify-center bg-amber-700 rounded-full border-4 border-white shadow-lg z-10 flex-shrink-0">
                    <i className="ri-star-fill text-2xl text-white"></i>
                  </div>

                  <div className="flex-1">
                    {index % 2 !== 0 && (
                      <div className="bg-white p-6 rounded-lg shadow-md">
                        <div className="text-3xl font-bold text-amber-700 mb-2">{item.year}</div>
                        <h3 className="text-2xl font-bold text-gray-900 mb-3">{item.title}</h3>
                        <p className="text-gray-700 leading-relaxed">{item.description}</p>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Our Team */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: '"Playfair Display", serif' }}>
              Meet Our Team
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Expert seamstress dedicated to bringing your vision to life
            </p>
          </div>

          <div className="flex justify-center">
            {team.map((member, index) => (
              <div key={index} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-shadow max-w-sm">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-80 object-cover object-top"
                />
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-1">{member.name}</h3>
                  <p className="text-amber-700 font-semibold mb-3">{member.role}</p>
                  <p className="text-gray-600 leading-relaxed">{member.bio}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Our Values */}
      <section className="py-20 bg-gray-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-6" style={{ fontFamily: '"Playfair Display", serif' }}>
              Our Values
            </h2>
            <p className="text-xl text-gray-300 max-w-2xl mx-auto">
              The principles that guide everything we do
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, index) => (
              <div key={index} className="text-center">
                <div className="w-20 h-20 flex items-center justify-center bg-amber-700 rounded-full mx-auto mb-4">
                  <i className={`${value.icon} text-3xl`}></i>
                </div>
                <h3 className="text-xl font-bold mb-3">{value.title}</h3>
                <p className="text-gray-300 leading-relaxed">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-20 bg-amber-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-5xl font-bold text-amber-700 mb-2">28+</div>
              <p className="text-gray-700 text-lg">Years in Business</p>
            </div>
            <div>
              <div className="text-5xl font-bold text-amber-700 mb-2">10,000+</div>
              <p className="text-gray-700 text-lg">Happy Customers</p>
            </div>
            <div>
              <div className="text-5xl font-bold text-amber-700 mb-2">2,500+</div>
              <p className="text-gray-700 text-lg">Wedding Dresses</p>
            </div>
            <div>
              <div className="text-5xl font-bold text-amber-700 mb-2">5-Star</div>
              <p className="text-gray-700 text-lg">Average Rating</p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
